import { useCallback } from "react";

import { AccountMenuItem } from "@/common/contracts/account.contracts";
import { NOTIFICATION_PREFERENCES_GATE } from "@/features/notification-preferences/static/notification-preferences.static";
import { useCanUseProBuyerProjects } from "@/features/pro-buyer-projects/components/ProProjectsGate";
import { useFeatureGate } from "@/features/statsig/gate.hooks";

/**
 * WHO-5959 6b. Filters the account menu: Pro Buyer-projecten shows only for
 * an approved Pro Buyer while the gateway's `pro_buyer_projects` flag is on.
 * WHO-5616: Notifications shows only while the `notification_preferences`
 * gate is on. Every other item is always visible.
 */
export const useAccountMenuItemVisibility = () => {
  const { canUse } = useCanUseProBuyerProjects();
  const { isEnabled: notificationPreferencesOn } = useFeatureGate(
    NOTIFICATION_PREFERENCES_GATE
  );

  return useCallback(
    (item: AccountMenuItem) =>
      (!item.proBuyerProjectsOnly || canUse) &&
      (!item.notificationPreferencesOnly || notificationPreferencesOn),
    [canUse, notificationPreferencesOn]
  );
};
